import { Alert } from '@mui/material'
import { makeStyles, createStyles } from '@mui/styles'
import { COLOR_DEFAULT_GREY } from '../../globalColors'
import AnnouncementIcon from '@mui/icons-material/Announcement'
import IconButton from '@mui/material/IconButton'
import { useEnv } from '@praxis/component-runtime-env'
import { useState } from 'react'

const useStyles = makeStyles((theme) =>
  createStyles({
    showingInfo: {
      margin: theme.spacing(1),
      alignItems: 'center',
      borderColor: COLOR_DEFAULT_GREY,
      '& .MuiAlert-icon > svg': {
        fill: COLOR_DEFAULT_GREY,
      },
    },
    coreSyncInfo: {
      margin: theme.spacing(1),
      alignItems: 'center',
    },
  }),
)

const StatusAlert = ({ text, noAction }) => {
  const classes = useStyles()
  const env = useEnv()
  const [showCoreSyncWarning, setShowCoreSyncWarning] = useState(false)
  const coreSyncWarning = env?.coreSyncWarning
  const coreSyncWarningMessage = env?.coreSyncWarningMessage

  const toggleCoreSyncWarning = () => {
    setShowCoreSyncWarning(!showCoreSyncWarning)
  }

  return (
    <>
      <Alert
        severity="info"
        variant="outlined"
        data-testid={'status-alert'}
        className={classes.showingInfo}
        action={
          noAction || !coreSyncWarning ? null : (
            <IconButton
              color="warning"
              aria-label="announcement"
              onClick={toggleCoreSyncWarning}
            >
              <AnnouncementIcon />
            </IconButton>
          )
        }
      >
        {text}
      </Alert>
      {coreSyncWarning && showCoreSyncWarning && (
        <Alert className={classes.coreSyncInfo} severity="warning">
          {coreSyncWarningMessage}
        </Alert>
      )}
    </>
  )
}

export default StatusAlert
